import { SVG, SVGProps } from './svg'

export function IconChevronDown(props: SVGProps) {
  return (
    <SVG {...props} viewBox={props.viewBox ?? '0 0 24 24'}>
      <path d="M12.7 15.8l-.5.2h-.4c-.2 0-.4 0-.5-.2L6 10.6a.5.5 0 010-.7l.8-.7a.5.5 0 01.7 0l4.4 4.5 4.4-4.5a.5.5 0 01.8 0l.7.7a.5.5 0 010 .7l-5.2 5.2z" />
    </SVG>
  )
}
